import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

export function PrivacyPolicyBackground() {
	const screens = useBreakpoint();
	return (
		<WrapperSection>
			<TextContainer className="animate__animated animate__fadeInUp animate__slow">
				<RATypography variant={screens?.md ? "h1" : "h2"} color="#222222" style={{ display: "inline" }}>
					Privacy Policy
				</RATypography>
				<RATypography
					variant="body3"
					color="#595959"
					style={{
						display: "inline",
						fontSize: screens.xs ? "14px" : "16px",
					}}
					top={20}
				>
					LAST UPDATED JUNE 14TH, 2023
				</RATypography>
			</TextContainer>
		</WrapperSection>
	);
}

const WrapperSection = styled.div`
	background-image: url("/images/private-jet-travel/private-jet-travel-mask.png");
	width: 100%;
	height: 50vh;
	/* Center and scale the image nicely */
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	@media (max-width: 767px) {
		height: 300px;
	}
`;
const TextContainer = styled.div`
	height: 100%;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
